import { Routes } from '@angular/router';
import { ProfileSettingsComponent } from './profile-settings/profile-settings.component';
import { AuthGuard } from '../../auth-guard.service';

export const CORE_ROUTES: Routes = [
    {
        path: 'profile', component: ProfileSettingsComponent, canActivate: [AuthGuard]
    }
];
